import React from 'react'

function CookiePolicy() {
  return (
    <div className='text-white'>CookiePolicy</div>
  )
}

export default CookiePolicy